"use client";

import { motion } from "framer-motion";

const BreathingCircles = () => (
  <div className="absolute inset-0 pointer-events-none overflow-hidden flex items-center justify-center">
    {[...Array(3)].map((_, i) => (
      <motion.div
        key={`breath-${i}`}
        className="absolute border border-[rgb(var(--color-neon-blue)_/_0.2)] rounded-full"
        animate={{
          scale: [1, 1.2, 1],
          opacity: [0.1, 0.2, 0.1],
        }}
        transition={{
          duration: 8,
          delay: i * 2,
          repeat: 1,
          ease: "easeInOut",
        }}
        style={{
          width: `${40 + i * 20}%`,
          height: `${40 + i * 20}%`,
        }}
      />
    ))}
  </div>
);

export const Header = () => (
  <motion.div
    className="flex flex-col items-center justify-center text-center relative pt-20 pb-16"
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
  >
    <BreathingCircles />
    <div className="space-y-6">
      <motion.span
        className="inline-flex px-4 py-2 rounded-full text-sm font-medium bg-[rgb(var(--color-neon-blue)_/_0.1)] text-[rgb(var(--color-neon-blue-light))] border border-[rgb(var(--color-neon-blue)_/_0.2)]"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.2 }}
      >
        Our Services
      </motion.span>
      <h2 className="text-4xl md:text-7xl font-bold tracking-[-0.02em] text-white">
        End-to-End Solutions
      </h2>
      <p className="text-lg md:text-xl text-white/80 max-w-2xl mx-auto leading-relaxed tracking-[0.01em]">
        Comprehensive IT services to help your business thrive in the digital
        age. Our proven approach ensures a reliable and secure foundation for
        your growth.
      </p>
    </div>
  </motion.div>
);
